/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type EmailVerificationCodeSendVariables = Types.Exact<{
  email: Types.Scalars['String']
}>

export type EmailVerificationCodeSend = {
  __typename: 'Root'
  emailVerificationCodeSend: {
    __typename: 'EmailVerificationCodeSendPayload'
    canUsePasswordAuth: boolean | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const EmailVerificationCodeSendDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EmailVerificationCodeSend' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailVerificationCodeSend' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canUsePasswordAuth' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type EmailVerificationCodeSendMutationFn = Apollo.MutationFunction<
  EmailVerificationCodeSend,
  EmailVerificationCodeSendVariables
>

/**
 * __useEmailVerificationCodeSend__
 *
 * To run a mutation, you first call `useEmailVerificationCodeSend` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVerificationCodeSend` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVerificationCodeSend, { data, loading, error }] = useEmailVerificationCodeSend({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailVerificationCodeSend(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EmailVerificationCodeSend,
    EmailVerificationCodeSendVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EmailVerificationCodeSend,
    EmailVerificationCodeSendVariables
  >(EmailVerificationCodeSendDocument, options)
}
export type EmailVerificationCodeSendHookResult = ReturnType<
  typeof useEmailVerificationCodeSend
>
export type EmailVerificationCodeSendMutationResult =
  Apollo.MutationResult<EmailVerificationCodeSend>
export type EmailVerificationCodeSendMutationOptions =
  Apollo.BaseMutationOptions<
    EmailVerificationCodeSend,
    EmailVerificationCodeSendVariables
  >
